module.exports = __webpack_public_path__ + "mainassets/img/graf2-2.a64c9a55.svg";